module.exports = "/static/assets/ff6e94eb50950a0d5b258a5c0eb42062.svg";